import { Divider } from "@mui/material";
import styled from "@emotion/styled";
import { gray500 } from "util/theme";

export const NavDivider = styled(Divider)`
  background-color: ${gray500};
  border: none;
  width: 1px;
  height: inherit;
`;
